import { render, staticRenderFns } from "./yesTimelineItem.vue?vue&type=template&id=163b96b6"
import script from "./yesTimelineItem.vue?vue&type=script&lang=js"
export * from "./yesTimelineItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports